const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // In development, config-overrides resolves web-vitals to the UMD CJS build whose
    // IIFE factory pattern webpack can't statically analyse for named exports.
    // Fall back to mod.default (the module.exports object) when named exports are absent.
    import('web-vitals').then((mod) => {
      const wv = (typeof mod.onCLS === 'function') ? mod : (mod.default || {});
      if (typeof wv.onCLS === 'function') wv.onCLS(onPerfEntry);
      if (typeof wv.onINP === 'function') wv.onINP(onPerfEntry);
      if (typeof wv.onFCP === 'function') wv.onFCP(onPerfEntry);
      if (typeof wv.onLCP === 'function') wv.onLCP(onPerfEntry);
      if (typeof wv.onTTFB === 'function') wv.onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
